import { TRACK_ADOPTION_METRICS_FOR_ASSET_DETAIL_VIEWED_EVENT, TRACK_ADOPTION_METRICS_FOR_COLLECTION_DETAIL_VIEWED_EVENT, TRACK_ADOPTION_METRICS_FOR_CONTENT_SEARCHED_EVENT, 
  TRACK_ADOPTION_METRICS_FOR_CONVERSATION_CLICKED_EVENT, TRACK_ADOPTION_METRICS_FOR_CONVERSATION_VIEWED_EVENT, TRACK_ADOPTION_METRICS_FOR_NEW_CHAT_CLICKED_EVENT, 
  TRACK_ADOPTION_METRICS_FOR_SEARCH_REACTED_EVENT, TRACK_ADOPTION_METRICS_FOR_SEEK_VIEW_CLICKED_EVENT, TRACK_ADOPTION_METRICS_FOR_STREAM_DETAIL_VIEWED_EVENT, 
  TRACK_EVENT_FOR_ADOPTION_REQUEST,
  TRACKING_EVENT_FOR_ADOPTION_FAILED,
  TRACKING_EVENT_FOR_ADOPTION_REQUEST,
  TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED,
  TRACK_ADOPTION_METRICS_FOR_GENERATE_LINK_EVENT,
  TRACK_ADOPTION_METRICS_FOR_SESSION_START_EVENT,
  TRACK_ADOPTION_METRICS_FOR_MEETING_PREP_CLICKED_EVENT,
  TRACK_ADOPTION_METRICS_FOR_LEARN_MORE_CLICKED_EVENT } 
  from "constants/adoptionActionTypes";
import { createAction } from 'redux-actions';
import { call, put, takeEvery } from "redux-saga/effects";
import { interceptPost } from "services/auth.interceptor";
import AuthService from "services/auth.service";
import EventService from "services/event.service";
import buildUrl from 'build-url';
import _ from "lodash";

const apiUrl = process.env.REACT_APP_API_URL;
const ADOPTION_BASE_URL = `${apiUrl}/api/2.0/adoption`;

// track event
export const trackEventForAdoptionAlias = createAction(TRACK_EVENT_FOR_ADOPTION_REQUEST);
export const trackingEventForAdoption = createAction(TRACKING_EVENT_FOR_ADOPTION_REQUEST);
export const trackingEventForAdoptionSucceeded = createAction(TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED);
export const trackingEventForAdoptionFailed = createAction(TRACKING_EVENT_FOR_ADOPTION_FAILED);

export function* trackEventForAdoption(event) {
  const distinctId = EventService.getMixpanelDistinctId();

  if (event && event.properties) {
    event.properties["distinct_id"] = distinctId;
    event.properties["platform"] = _.get(event.properties, "platform", "Chrome Extension");
  }

  try {
    yield put(trackingEventForAdoption());

    let url = buildUrl(ADOPTION_BASE_URL, {
      path: `/event`
    });

    const requestPayload = {
      ...event,
      properties: event.properties ? JSON.stringify(event.properties) : null
    };

    const authToken = AuthService.getAccessToken();

    const response = yield call(interceptPost, url, requestPayload, authToken);
    yield put(trackingEventForAdoptionSucceeded());
  } catch (error) {
    console.error("API call failed:", error);
    yield put(trackingEventForAdoptionFailed(error));
  }
}

//conversation clicked

export const trackAdoptionMetricsForConversationClickedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_CONVERSATION_CLICKED_EVENT, (event_name) => ({ event_name }));

function* trackAdoptionMetricsForConversationClickedEventSaga(action) {

  const { event_name } = action.payload;

  const data = {
    event: event_name,
    properties: {}
  }

  yield call(trackEventForAdoption, data);
}

//conversation viewed
export const trackAdoptionMetricsForConversationViewedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_CONVERSATION_VIEWED_EVENT, (event_name) => ({ event_name }));

function* trackAdoptionMetricsForConversationViewedEventSaga(action) {

  const { event_name } = action.payload;

  const data = {
    event: event_name,
    properties: {}
  }

  yield call(trackEventForAdoption, data);
}

//asset detail viewed
export const trackAdoptionMetricsForAssetDetailViewedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_ASSET_DETAIL_VIEWED_EVENT,
  (event_name, source_cta, asset_type, platform) => ({ event_name, source_cta, asset_type, platform }));

function* trackAdoptionMetricsForAssetDetailViewedEventSaga(action) {

  const { event_name, source_cta, asset_type, platform } = action.payload;

  const data = {
    event: event_name,
    properties: {
      source_cta: source_cta,
      asset_type: asset_type,
      platform: platform
    }
  }

  yield call(trackEventForAdoption, data);
}


//stream detail viewed

export const trackAdoptionMetricsForStreamDetailViewedEvent = createAction(
  TRACK_ADOPTION_METRICS_FOR_STREAM_DETAIL_VIEWED_EVENT,
  (event_name, stream_name, platform) => ({ event_name, stream_name, platform })
);

function* trackEventForStreamDetailViewAdoptionSaga(action) {

  const { event_name, stream_name, platform } = action.payload;

  const data = {
    event: event_name,
    properties: {
      stream_name: stream_name,
      platform: platform
    }
  }

  yield call(trackEventForAdoption, data);
}

//collection detail viewed

export const trackAdoptionMetricsForCollectionDetailViewedEvent = createAction(
  TRACK_ADOPTION_METRICS_FOR_COLLECTION_DETAIL_VIEWED_EVENT,
  (event_name, collection_name, platform) => ({ event_name, collection_name, platform })
);

function* trackEventForCollectionDetailViewAdoptionSaga(action) {

  const { event_name, collection_name, platform } = action.payload;

  const data = {
    event: event_name,
    properties: {
      collection_name: collection_name,
      platform: platform
    }
  }

  yield call(trackEventForAdoption, data);
}

//content searched
export const trackAdoptionMetricsForContentSearchedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_CONTENT_SEARCHED_EVENT, (event_name, source_cta, search_string, filter, search_tags, categories, platform) => 
  ({ event_name, source_cta, search_string, filter, search_tags, categories, platform }));

function* trackAdoptionMetricsForContentSearchedEventSaga(action) {

  const { event_name, source_cta, search_string, filter, search_tags, categories, platform } = action.payload;

  const data = {
    event: event_name,
    properties: {
      source_cta: source_cta,
      search_string: search_string,
      filter: filter,
      search_tags: search_tags,
      categories: categories,
      platform: platform
    }
  }

  yield call(trackEventForAdoption, data);
}

//seek view clicked
export const trackAdoptionMetricsForSeekViewClickedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_SEEK_VIEW_CLICKED_EVENT, (event_name) => ({ event_name }));

function* trackAdoptionMetricsForSeekViewClickedEventSaga(action) {

  const { event_name } = action.payload;

  const data = {
    event: event_name,
    properties: {}
  }

  yield call(trackEventForAdoption, data);
}

//new chat clicked
export const trackAdoptionMetricsForNewChatClickedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_NEW_CHAT_CLICKED_EVENT, (event_name) => ({ event_name }));

function* trackAdoptionMetricsForNewChatClickedEventSaga(action) {
  
    const { event_name } = action.payload;
  
    const data = {
      event: event_name,
      properties: {}
    }
  
    yield call(trackEventForAdoption, data);
  }

//search reacted
export const trackAdoptionMetricsForSearchReactedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_SEARCH_REACTED_EVENT, (event_name, reactionType) => 
  ({ event_name, reactionType }));

function* trackAdoptionMetricsForSearchReactedEventSaga(action) {
  
    const { event_name, reactionType } = action.payload;
  
    const data = {
      event: event_name,
      properties: {
        reactionType: reactionType
      }
    }
  
    yield call(trackEventForAdoption, data);
  }

export const trackAdoptionMetricsForGenerateLinkEvent = createAction(TRACK_ADOPTION_METRICS_FOR_GENERATE_LINK_EVENT, (event_name, source_cta, link_type, collection_name) => 
  ({ event_name, source_cta, link_type, collection_name }));

function* trackAdoptionMetricsForGenerateLinkEventSaga(action) {
  
    const { event_name, source_cta, link_type, collection_name } = action.payload;
  
    const data = {
      event: event_name,
      properties: {
        source_cta: source_cta,
        link_type: link_type,
        collection_name: collection_name
      }
    }
  
    yield call(trackEventForAdoption, data);
  }

export const trackAdoptionMetricsForSessionStartEvent = createAction(TRACK_ADOPTION_METRICS_FOR_SESSION_START_EVENT, (event_name) => 
  ({ event_name }));

function* trackAdoptionMetricsForSessionStartEventSaga(action) {
  
    const { event_name } = action.payload;
  
    const data = {
      event: event_name,
      properties: {}
    }
  
    yield call(trackEventForAdoption, data);
  }

  // meeting prep clicked
    export const trackAdoptionMetricsForMeetingPrepClickedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_MEETING_PREP_CLICKED_EVENT, (event_name) =>
      ({ event_name }));

    function* trackAdoptionMetricsForMeetingPrepClickedEventSaga(action) {

      const { event_name } = action.payload;

      const data = {
        event: event_name,
        properties: {}
      }

      yield call(trackEventForAdoption, data);
    }

  // learn more clicked
    export const trackAdoptionMetricsForLearnMoreClickedEvent = createAction(TRACK_ADOPTION_METRICS_FOR_LEARN_MORE_CLICKED_EVENT, (event_name, source_cta) =>
      ({ event_name, source_cta }));

    function* trackAdoptionMetricsForLearnMoreClickedEventSaga(action) {

      const { event_name, source_cta } = action.payload;

      const data = {
        event: event_name,
        properties: {
          source_cta: source_cta
        }
      }
      
      yield call(trackEventForAdoption, data);
    } 

export default function* eventsSaga() {
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_STREAM_DETAIL_VIEWED_EVENT, trackEventForStreamDetailViewAdoptionSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_CONVERSATION_VIEWED_EVENT, trackAdoptionMetricsForConversationViewedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_ASSET_DETAIL_VIEWED_EVENT, trackAdoptionMetricsForAssetDetailViewedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_COLLECTION_DETAIL_VIEWED_EVENT, trackEventForCollectionDetailViewAdoptionSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_CONVERSATION_CLICKED_EVENT, trackAdoptionMetricsForConversationClickedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_CONTENT_SEARCHED_EVENT, trackAdoptionMetricsForContentSearchedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_SEEK_VIEW_CLICKED_EVENT, trackAdoptionMetricsForSeekViewClickedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_NEW_CHAT_CLICKED_EVENT, trackAdoptionMetricsForNewChatClickedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_SEARCH_REACTED_EVENT, trackAdoptionMetricsForSearchReactedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_GENERATE_LINK_EVENT, trackAdoptionMetricsForGenerateLinkEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_SESSION_START_EVENT, trackAdoptionMetricsForSessionStartEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_MEETING_PREP_CLICKED_EVENT, trackAdoptionMetricsForMeetingPrepClickedEventSaga);
  yield takeEvery(TRACK_ADOPTION_METRICS_FOR_LEARN_MORE_CLICKED_EVENT, trackAdoptionMetricsForLearnMoreClickedEventSaga);
};